// extracted by mini-css-extract-plugin
export default {"actionBtn":"f942a628b31ee2df"};